<template>
  <nav-bar title="钢瓶流通管理" />
  <Content :bottom="0" ref="content">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <div ref="container">
      <div class="title">
        <span>{{ detail.departName }}</span>
        <span>{{ detail.groupName }}</span>
      </div>
      <van-cell title="空瓶(只记录本组)" :value="detail.emptyCount" />
      <van-cell title="实瓶(只记录本组)" :value="detail.fullCount" />
      <van-cell title="用户钢瓶" :value="detail.onSaleCount" />
      <van-search
        ref="search"
        v-model="words"
        placeholder="钢瓶查询"
        input-align="center"
        @search="onSearch"
      />
    </div>
    <div class="search-content" ref="searchContent">
      <Content :top="0" :bottom="0">
        <Loading v-if="showSearchLoading" :isLoading="isSearchLoading">
          <p>加载失败</p>
          <van-button type="primary" size="small" @click="onSearch(words)"
            >刷新</van-button
          >
        </Loading>
        <ul v-if="list.length" class="list">
          <li
            class="list-item"
            v-for="item in list"
            :key="item.customerId"
            @click.stop="handleComClick(item)"
          >
            {{ item.customerName }} {{ item.cylinderCount }}瓶
          </li>
        </ul>
        <Empty v-else description="无查询结果" />
      </Content>
    </div>
  </Content>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { getAgentMesslist, getAgentCustomerMesslist } from '@/api/steelCylinder'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
export default {
  name: 'CylinderCirculationManagementDetail', // 钢瓶流通管理详情
  props: ['id'],
  setup(props) {
    const router = useRouter()
    //  获取详细
    const detail = ref({})
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getAgentMesslist,
      (data) => {
        detail.value = data
        onSearch()
      },
      props.id
    )
    getDataLoading()

    // search
    const words = ref('')
    const list = ref([])
    const showSearchLoading = ref(false)
    const isSearchLoading = ref(false)
    const onSearch = (value) => {
      const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
        getAgentCustomerMesslist,
        (data) => {
          list.value = data
        },
        { departId: detail.value.groupId, cName: value }
      )
      watch(showLoading, (val) => {
        showSearchLoading.value = val
      })
      watch(isLoading, (val) => {
        isSearchLoading.value = val
      })
      getDataLoading()
    }
    // 下钻
    const handleComClick = (item) => {
      router.push(`/cylinderListById/${item.customerId}`)
    }
    // 计算搜索结果的高度
    const container = ref(null)
    const searchContent = ref(null)
    const content = ref(null)
    window.onresize = () => {
      setSize()
    }
    onMounted(() => {
      setSize()
    })
    const setSize = () => {
      const contentHeight = content.value.$el.offsetHeight
      const containerHeight = container.value.offsetHeight
      searchContent.value.style.height = contentHeight - containerHeight + 'px'
    }
    return {
      getDataLoading,
      showLoading,
      isLoading,
      detail,
      container,
      searchContent,
      content,
      words,
      onSearch,
      list,
      showSearchLoading,
      isSearchLoading,
      handleComClick
    }
  }
}
</script>

<style lang="scss" scoped>
.van-search {
  padding: 16px;
}
.title {
  padding: 16px;
  font-size: 16px;
  span {
    margin-right: 10px;
  }
}
.search-content {
  position: relative;
  overflow: hidden;
  .list {
    padding: 0 16px 16px 16px;
    font-size: 14px;
    .list-item {
      padding: 14px;
      background-color: #fff;
      box-shadow: rgba(42, 45, 51, 0.25) 0px 4px 8px -2px,
        rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
      margin-top: 16px;
    }
  }
}
</style>
